import { COLORS } from 'src/shared/styles/colors';
import { E_ICONS } from 'src/ui/components/Icons/constants';
export var E_TYPE_HISTORY_FILTER;
(function (E_TYPE_HISTORY_FILTER) {
    E_TYPE_HISTORY_FILTER["STATUT"] = "STATUT";
    E_TYPE_HISTORY_FILTER["MESSAGES"] = "MESSAGES";
    E_TYPE_HISTORY_FILTER["ETUDE_DU_DOSSIER"] = "ETUDE_DU_DOSSIER";
    E_TYPE_HISTORY_FILTER["COMPLETION"] = "COMPLETION";
    E_TYPE_HISTORY_FILTER["OTHER"] = "OTHER";
})(E_TYPE_HISTORY_FILTER || (E_TYPE_HISTORY_FILTER = {}));
export var messageFilter = {
    icon: E_ICONS.MESSAGE,
    color: {
        backgroundColor: COLORS.BLUE['100'],
        icon: COLORS.BLUE['500'],
    },
    tooltipKeyPath: 'timeline.filterLabels.message',
    type: E_TYPE_HISTORY_FILTER.MESSAGES,
};
export var etudeDossierFilter = {
    icon: E_ICONS.BRIEFCASE,
    color: {
        backgroundColor: COLORS.RED['100'],
        icon: COLORS.RED['500'],
    },
    tooltipKeyPath: 'timeline.filterLabels.study',
    type: E_TYPE_HISTORY_FILTER.ETUDE_DU_DOSSIER,
};
export var completionFilter = {
    icon: E_ICONS.GROUP,
    color: {
        backgroundColor: COLORS.GREEN['100'],
        icon: COLORS.GREEN['500'],
    },
    tooltipKeyPath: 'timeline.filterLabels.kyc',
    type: E_TYPE_HISTORY_FILTER.COMPLETION,
};
export var otherFilter = {
    icon: E_ICONS.CALENDAR,
    color: {
        backgroundColor: COLORS.GRAY['100'],
        icon: COLORS.GRAY['500'],
    },
    tooltipKeyPath: 'timeline.filterLabels.other',
    type: E_TYPE_HISTORY_FILTER.OTHER,
};
export var INFORMATION_IDS_IDENTITIES = ['_applicant-0_identityStatusReason', '_applicant-0_identityStatus'];
export var APPLICANT_NUMBER_PLACEHOLDER = '${number}';
